import { render, staticRenderFns } from "./ViewLedger.vue?vue&type=template&id=0fdf567c&scoped=true"
import script from "./ViewLedger.vue?vue&type=script&lang=js"
export * from "./ViewLedger.vue?vue&type=script&lang=js"
import style0 from "./ViewLedger.vue?vue&type=style&index=0&id=0fdf567c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf567c",
  null
  
)

export default component.exports